import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-slate-950 text-slate-400 py-4 pb-24 border-t border-slate-800" data-id="element-33">
      <div className="max-w-[1200px] mx-auto px-4" data-id="element-34">
        <div className="flex flex-col items-center justify-center text-center mb-4" data-id="element-35">
          <div className="flex items-center justify-center mb-3" data-id="element-36">
            <ShieldCheck className="w-8 h-8 text-slate-600 mr-3" data-id="element-37" />
            <div className="text-left" data-id="element-38">
              <p className="text-white font-heading font-bold text-lg uppercase tracking-widest" data-id="element-39">
                🏅 OFICIAL
              </p>
              <p className="text-xs font-bold tracking-widest uppercase" data-id="element-40">
                7 DÍAS GARANTÍA
              </p>
            </div>
          </div>
          <p className="max-w-md text-xs" data-id="element-41">
            <strong className="text-slate-300" data-id="element-42">
              Garantía segura de 7 días.
            </strong>{' '}
            Probá el manual durante 7 días. Si sentís que no es para vos, te
            devolvemos el 100% del dinero.
          </p>
        </div>
        <div className="border-t border-slate-800 pt-4 flex flex-col md:flex-row items-center justify-between text-xs" data-id="element-43">
          <p data-id="element-44">
            © {new Date().getFullYear()} Sistema Maestro de Herrería™. Todos
            los derechos reservados.
          </p>
          <div className="flex space-x-4 mt-3 md:mt-0" data-id="element-45">
            <a href="#" className="hover:text-white transition-colors" data-id="element-46">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-47">
              Políticas de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-48">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}